import FlexPane from './_flex-pane.js'
import Participants from './_participants.js'
import MiniScoreboard from './_mini-scoreboard.js'

export default {
  name: 'EventListItemDetails',
  values: {
    container: {
      configSet: FlexPane,
      configValues: {
        itemSpacing: '4px',
        style: {
          justifyContent: 'center',
          flexDirection: 'column',
          padding: '0px 8px 0px 0px',
        },
      },
    },
    participantsAndScoreContainer: {
      configSet: FlexPane,
      configValues: {
        style: {
          flexGrow: 2,
        },
      },
    },
    participants: {
      configSet: Participants,
      configValues: {},
    },
    scoreboard: {
      configSet: MiniScoreboard,
      configValues: {
        stretch: true,
        showSegmentIndicators: true,
        threeWayLayout: false,
        padding: 0,
        segmentIndicators: {
          top: -24,
        },
      },
    },
  },
  meta: {
    extendable: false,
  },
}
